import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import WhatsappButton from "./Components/WhatsappButton/WhatsappButton";
import Loader from "./Components/Loader/Loader";

import WhoWeAre from "./Components/what/WhoWeAre";
import Services from "./Components/Services/Services";
import WhatWeDo from "./Components/WhatWeDo/WhatWeDo";
import RoadMap from "./Components/RoadMap/RoadMap";
import Supporters from "./Components/Supporters/Supporters";
import Contact from "./Components/Contact/Contact";
import OurProjects from "./Components/OurProjects/OurProjects";
import About from "./Components/About/About";
import Gallery from "./Components/Gallery/Gallery";
import AdminLogin from "./Components/AdminLogin/AdminLogin";
import Admin from "./Components/Admin/Admin";
import AdminNavbar from "./Components/AdminNavbar/AdminNavbar";
import Donate from "./Components/Donate/Donate";
import Home from "./Components/Home/Home";
import Addsupport from "./Components/Addsupport/Addsupport";
import Galleryupload from "./Components/Galleryupload/Galleryupload";
import Terms from "./Components/Terms/Terms";
import Privacy from "./Components/Privacy/Privacy";
import Refund from "./Components/Refund/Refund";
import History from "./Components/History/History";

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  // 🔹 Loader trigger on route change
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 700); // loader duration (adjust panna mudiyum)

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Paths where navbar & footer must be hidden
  const hideLayout = [
    "/adminlogin",
    "/admin",
    "/addsupport",
    "/galleryupload",
    "/addtrustee",
    "/update",
    "/history"
  ].includes(location.pathname);

  const showWhatsapp = !hideLayout;

  return (
    <>
      {loading && <Loader />}

      {/* Admin Navbar */}
      {[
        "/admin",
        "/addsupport",
        "/galleryupload",
        "/addtrustee",
        "/update",
        "/history"
      ].includes(location.pathname) && <AdminNavbar />}

      {/* Main Navbar */}
      {!hideLayout && <Navbar />}

      <Routes>
        <Route
          index
          element={
            <>
              <Home />
              <WhoWeAre />
              <WhatWeDo />
              <Services />
              <RoadMap />
              <Supporters />
            </>
          }
        />

        <Route path="/contact" element={<Contact />} />
        <Route path="/ourprojects" element={<OurProjects />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />

        {/* Admin pages */}
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/addsupport" element={<Addsupport />} />
        <Route path="/galleryupload" element={<Galleryupload />} />
        <Route path="/history" element={<History/>}/>
      </Routes>

      {!hideLayout && <Footer />}
      {showWhatsapp && <WhatsappButton />}
    </>
  );
}

export default function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
